import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Text,
  TextField,
  Card,
  Flex,
} from "@aws-amplify/ui-react";

export const ViewError = () => {
    return <h2>Ooops, page not found!</h2>
}